import WebGalleryAccountCards from './WebGalleryAccountCards';

export default WebGalleryAccountCards;
